
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1UKaF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a16339f92cd39e58252a582b600e90a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $164ed607429e56c8$var$_react = $164ed607429e56c8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $164ed607429e56c8$var$_baseNew = $164ed607429e56c8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $164ed607429e56c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/zoom-in
 * Usage guidance:
 * Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $164ed607429e56c8$var$ZoomInIcon = (props)=>/*#__PURE__*/ $164ed607429e56c8$var$_react.default.createElement($164ed607429e56c8$var$_baseNew.default, Object.assign({
        name: "ZoomInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m5.25.75V10h1.5V7.75H10v-1.5H7.75V4h-1.5v2.25H4v1.5z" clip-rule="evenodd"/>`
    }, props));
$164ed607429e56c8$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $164ed607429e56c8$var$_default = module.exports.default = $164ed607429e56c8$var$ZoomInIcon;

});


//# sourceMappingURL=zoom-in.189dcae5.js.map
